/* eslint-disable prettier/prettier */
import localize from '../localize';
import vardagaFilters from './vardaga-website';
import altidenFilters from './altiden-website';
import stendiFilters from './stendi-website';

const isNewTransform = (items) => {
  let trueObj = items.find((o) => o.value === 'true');
  if (!trueObj) {
    return items;
  }

  trueObj.label = localize('is_new') || 'Is new';

  items = [trueObj];

  return items;
};

const defaultFilters = [
  {
    key: 'tjanst',
    position: 'top',
    attribute: 'taxonomies.Tjänst',
    copyKey: 'typeOfHome',
    copySelect: 'chooseType',
  },
  {
    key: 'lan',
    position: 'top',
    attribute: 'taxonomies.Län',
    copyKey: 'region',
    copySelect: 'selectRegion',
  },
  {
    key: 'kommun',
    position: 'top',
    attribute: 'taxonomies.kommun',
    copyKey: 'municipality',
    copySelect: 'selectMunicipality',
  },
  {
    key: 'search',
    position: 'top',
    copyKey: 'searchTitle',
    copyPlaceholder: 'searchTitle',
  },
  {
    key: 'malgrupp',
    position: 'panel',
    attribute: 'taxonomies.Målgrupp',
    copyKey: 'targetGroup',
  },
  {
    key: 'segment',
    position: 'panel',
    attribute: 'taxonomies.Segment',
    copyKey: 'segmentTitle',
  },
  {
    key: 'personkrets',
    position: 'panel',
    attribute: 'taxonomies.Personkrets inom LSS',
    copyKey: 'personalWithinLss',
  },
  {
    key: 'sswsDriftsform',
    position: 'panel',
    attribute: 'metadata.ssws_driftsform',
    copyKey: 'operatingMode',
  },
  {
    key: 'lagrum',
    position: 'panel',
    attribute: 'taxonomies.Lagrum',
    copyKey: 'law',
  },
  /*{
    key: 'diagnos',
    position: 'panel',
    attribute: 'taxonomies.Diagnos/specialiteter',
    copyKey: 'diagnosTitle'
  },*/
  {
    key: 'sswsIsNew',
    position: 'panel',
    attribute: 'metadata.ssws_is-new',
    copyKey: 'isNew',
    transform: isNewTransform,
  },
];

var exportedFilters = defaultFilters;

const theme = localize('svb_active_theme') || '';

if (theme === 'vardaga-website') {
  exportedFilters = vardagaFilters;
}

if (theme === 'altiden-website') {
  exportedFilters = altidenFilters;
}
if (theme === 'stendi-website') {
  exportedFilters = stendiFilters;
}

export default exportedFilters;
